import { Routes, Route, Link } from 'react-router-dom'

function SubEventEnd2() {
    return(
        <>
            <div className='event-ongoing-subpage'>
              <div className='event-ongoing-subpage-subject'>
                <h1>펫 자랑 이벤트</h1>
                <p>2024-01-12 ~ 2024-01-19</p>
              </div>
              <div className='event-ongoing-subpage-img'><img src={process.env.PUBLIC_URL + '/img/.png'} /></div>
            </div>
        </>
    )
}

export default SubEventEnd2;